<h2 mat-dialog-title>
  <mat-icon class="dialog-title-icon">bug_report</mat-icon>
  Report Finding
</h2>

<mat-dialog-content>
  <div class="finding-summary">
    <div class="finding-summary-row">
      <span class="finding-badge" [ngClass]="'badge-' + data.finding.severity">
        {{ data.finding.findingType }}
      </span>
      <span class="finding-pages">p{{ data.finding.sourcePage }} &rarr; p{{ data.finding.targetPage }}</span>
    </div>
    <p class="finding-detail-preview">{{ data.finding.detail }}</p>
    <div class="finding-meta-line">
      {{ data.environmentLabel | uppercase }} &middot; {{ data.projectId }} &middot; {{ data.finding.edgeType }}
    </div>
  </div>

  <mat-form-field appearance="outline" class="full-width analysis-field">
    <mat-label>What's wrong with this finding?</mat-label>
    <textarea
      matInput
      [(ngModel)]="analysis"
      rows="4"
      placeholder="e.g., I don't see this contradiction in the PDF. The designer name appears correct on both pages..."
    ></textarea>
    <mat-hint>Describe why this finding is incorrect or needs investigation</mat-hint>
  </mat-form-field>

  <mat-form-field appearance="outline" class="full-width">
    <mat-label>Root cause category</mat-label>
    <mat-select [(ngModel)]="rootCause">
      @for (cat of rootCauseCategories; track cat.value) {
        <mat-option [value]="cat.value"> {{ cat.label }} &mdash; {{ cat.description }} </mat-option>
      }
    </mat-select>
  </mat-form-field>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button mat-dialog-close>Cancel</button>
  <button mat-flat-button color="primary" [disabled]="isSubmitDisabled" (click)="submit()">
    <mat-icon>bug_report</mat-icon>
    File Issue
  </button>
</mat-dialog-actions>
